import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const ADMIN_EMAIL = 'joe1993119@gmail.com';

interface AdminRouteProps {
  children: React.ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { user, loading, isLoggedIn } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="flex flex-col items-center gap-3">
          <i className="ri-loader-4-line text-4xl text-teal-500 animate-spin"></i>
          <p className="text-gray-500 text-sm">驗證管理員身份中...</p>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (user?.email !== ADMIN_EMAIL) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
